'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _makerActions = require('../../actions/makerActions');

var _ComponentOptions = require('./ComponentOptions');

var _ComponentOptions2 = _interopRequireDefault(_ComponentOptions);

var _ReportOptions = require('./ReportOptions');

var _ReportOptions2 = _interopRequireDefault(_ReportOptions);

var _TextEditor = require('./TextEditor');

var _TextEditor2 = _interopRequireDefault(_TextEditor);

var _MakerChart = require('./MakerChart');

var _MakerChart2 = _interopRequireDefault(_MakerChart);

var _Images = require('./Images');

var _Images2 = _interopRequireDefault(_Images);

var _ComponentPrototypes = require('./ComponentPrototypes');

var componentPrototypes = _interopRequireWildcard(_ComponentPrototypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import unqiueId from 'lodash.uniqueid';


var ReportMaker = function (_React$Component) {
	_inherits(ReportMaker, _React$Component);

	function ReportMaker(props) {
		_classCallCheck(this, ReportMaker);

		var _this = _possibleConstructorReturn(this, (ReportMaker.__proto__ || Object.getPrototypeOf(ReportMaker)).call(this, props));

		_this.state = {
			selectedComponent: false
		};
		return _this;
	}

	_createClass(ReportMaker, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (this.props.report.components.length < nextProps.report.components.length) {
				this.setState({
					selectedComponent: nextProps.report.components.length - 1
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {

			return _react2.default.createElement(
				'div',
				{ className: 'report-maker' },
				_react2.default.createElement(
					'div',
					{ className: 'sidebar' },
					_react2.default.createElement(
						'div',
						{ className: 'title' },
						_react2.default.createElement(
							'div',
							{ className: 'pull-right cancel' },
							this.getSidebarTitleAction.bind(this)()
						),
						this.getSidebarTitle.bind(this)()
					),
					_react2.default.createElement(
						'div',
						{ className: 'sidebar-content' },
						this.getSidebarContent.bind(this)()
					),
					_react2.default.createElement(
						'div',
						{ className: 'submit', onClick: this.submit.bind(this) },
						'Save'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'report-preview', onClick: this.handlePreviewAreaClick.bind(this) },
					_react2.default.createElement(
						'div',
						{ className: 'page' },
						_react2.default.createElement(
							'div',
							{ className: 'report-title' },
							this.props.report.title,
							this.props.report.description && _react2.default.createElement(
								'div',
								{ className: 'report-description' },
								this.props.report.description
							)
						),
						this.reportSections.bind(this)(),
						this.renderAddComponentButton.bind(this)()
					)
				)
			);
		}
	}, {
		key: 'renderAddComponentButton',
		value: function renderAddComponentButton() {
			return _react2.default.createElement(
				'div',
				{ className: 'add-component-buttons' },
				_react2.default.createElement(
					'div',
					{ onClick: this.handleAddComponent.bind(this, 'chart'), className: 'report-btn' },
					_react2.default.createElement('img', { src: IMG_URL + 'icons_chart-bar.png', alt: '' })
				),
				_react2.default.createElement(
					'div',
					{ onClick: this.handleAddComponent.bind(this, 'images'), className: 'report-btn' },
					_react2.default.createElement('img', { src: IMG_URL + 'icons_pictures.png', alt: '' })
				),
				_react2.default.createElement(
					'div',
					{ onClick: this.handleAddComponent.bind(this, 'text'), className: 'report-btn' },
					_react2.default.createElement('img', { src: IMG_URL + 'icons_text.png', alt: '' })
				)
			);
		}
	}, {
		key: 'reportSections',
		value: function reportSections() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'report-sections' },
				this.props.report.components.map(function (component, i) {
					return _react2.default.createElement(
						'div',
						{
							className: (0, _classnames2.default)("report-component", "report-component-" + component.type, { selected: i === _this2.state.selectedComponent }),
							key: component.id,
							onClick: _this2.handleSelectComponent.bind(_this2, i)
						},
						_this2.renderComponent(component, i),
						_this2.renderComponentTools(i)
					);
				})
			);
		}
	}, {
		key: 'renderComponent',
		value: function renderComponent(component, i) {

			switch (component.type) {
				case 'text':
					return _react2.default.createElement(_TextEditor2.default, {
						componentIndex: i,
						editorState: component.editorState,
						data: component.data,
						component: component
					});
				case 'chart':
					return _react2.default.createElement(_MakerChart2.default, {
						componentIndex: i,
						data: component
					});
				case 'images':
					return _react2.default.createElement(_Images2.default, {
						componentIndex: i,
						data: component
					});
				default:
					return _react2.default.createElement(
						'h2',
						null,
						component.type
					);
			}
		}
	}, {
		key: 'renderComponentTools',
		value: function renderComponentTools(i) {
			return _react2.default.createElement(
				'div',
				{ className: 'component-tools' },
				_react2.default.createElement(
					'div',
					{ className: 'up', onClick: this.handleMoveComponent.bind(this, i, 'up') },
					_react2.default.createElement('i', { className: 'ri-arrow-up-o' })
				),
				_react2.default.createElement(
					'div',
					{ className: 'down', onClick: this.handleMoveComponent.bind(this, i, 'down') },
					_react2.default.createElement('i', { className: 'ri-arrow-down-o' })
				)
			);
		}
	}, {
		key: 'handleMoveComponent',
		value: function handleMoveComponent(i, dir, e) {
			var _this3 = this;

			e.preventDefault();
			e.stopPropagation();
			this.setState({
				selectedComponent: false
			}, function () {
				_this3.props.dispatch((0, _makerActions.moveComponent)(i, dir));
			});
		}
	}, {
		key: 'handleAddComponent',
		value: function handleAddComponent(type) {
			var newComponent = componentPrototypes[type];
			this.props.dispatch((0, _makerActions.addComponent)(newComponent));
		}
	}, {
		key: 'handleSelectComponent',
		value: function handleSelectComponent(index) {

			this.setState({
				selectedComponent: index
			});
		}
	}, {
		key: 'handlePreviewAreaClick',
		value: function handlePreviewAreaClick(e) {

			if (!e.target.closest('.report-component, .report-btn')) {
				this.setState({ selectedComponent: false });
			}
		}
	}, {
		key: 'handleDeleteSection',
		value: function handleDeleteSection(index) {
			this.setState({ selectedComponent: false });
			this.props.dispatch((0, _makerActions.removeComponent)(index));
		}
	}, {
		key: 'getSidebarTitle',
		value: function getSidebarTitle() {

			if (this.state.selectedComponent === false) return 'New Report';

			var type = this.props.report.components[this.state.selectedComponent].type;

			return type.charAt(0).toUpperCase() + type.slice(1);
		}
	}, {
		key: 'getSidebarTitleAction',
		value: function getSidebarTitleAction() {

			if (this.state.selectedComponent === false) {
				return _react2.default.createElement(
					'div',
					{ onClick: function onClick() {
							return document.location = '/reports/';
						} },
					'Exit'
				);
			}

			return _react2.default.createElement(
				'div',
				{ onClick: this.handleDeleteSection.bind(this, this.state.selectedComponent) },
				'Delete Section'
			);
		}
	}, {
		key: 'getSidebarContent',
		value: function getSidebarContent() {

			if (this.state.selectedComponent === false) return _react2.default.createElement(_ReportOptions2.default, null);

			var component = _extends({}, this.props.report.components[this.state.selectedComponent]);
			var type = component.type;

			return _react2.default.createElement(_ComponentOptions2.default, {
				type: type,
				selectedComponent: this.state.selectedComponent,
				component: component
			});
		}
	}, {
		key: 'submit',
		value: function submit() {
			this.props.dispatch((0, _makerActions.submitReport)());
		}
	}]);

	return ReportMaker;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		report: state
	};
};

ReportMaker = (0, _reactRedux.connect)(mapStateToProps)(ReportMaker);

exports.default = ReportMaker;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/reportMaker.js
// module id = 516
// module chunks = 0